import type { ReactNode } from 'react'

import { MetricCard } from './domain-overview-metric-card.atom'
import type { DomainOverviewMetric } from './split-view.interface'

export interface DomainOverviewMetricsProps {
  metricList: DomainOverviewMetric[]
}

export const DomainOverviewMetrics: React.FC<DomainOverviewMetricsProps> = ({
  metricList,
}): ReactNode => (
  <div className="domain-metrics">
    <h3 className="mb-3 text-sm font-semibold">Metrics & Performance</h3>
    <div className="grid grid-cols-2 gap-2">
      {metricList.map((metric) => (
        <MetricCard key={metric.label} metric={metric} />
      ))}
    </div>
  </div>
)
